import { render } from "./MiniPagePreview.vue?vue&type=template&id=15651135&scoped=true"
import script from "./MiniPagePreview.vue?vue&type=script&lang=js"
export * from "./MiniPagePreview.vue?vue&type=script&lang=js"

import "./MiniPagePreview.vue?vue&type=style&index=0&id=15651135&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15651135"]])

export default __exports__